export const base_filter = [
	{ key: "name", label: "Nombre", type: "text", value: "", visible: true, placeholder: "Nombre" },
	{ key: "description", label: "Descripción", type: "text", value: "", visible: true, placeholder: "Descripción" },
];

export const base_table = { page: 1, per_page: 100, order_by: "name", order_dir: "asc", search: "" };

export const base_object = { id: "", name: "", description: "", estates_ids: [], estates_parents_ids: [] };
